
import {Vue, Prop, Watch, Component} from 'vue-property-decorator'
import Destination from '../models/Destination';
import PassengerDestination from '../models/PassengerDestination';

@Component({})
export default class SecondaryDestinationPicker extends Vue {

  secondaryDestinationId: number | undefined | null = null;

  @Prop({default: null}) private value: number | undefined | null;
  @Prop({ default: null }) private mainDestination: PassengerDestination;
  @Prop({ default: false }) private disabled: boolean;
  
  @Watch('value', { immediate: true }) onValueChanged() {
    this.secondaryDestinationId = this.value;
  }

  @Watch('mainDestination', { immediate: true }) onMainDestinationChanged() {
    console.log('mainDestination changed');
    if(this.mainDestination.destinationId === this.secondaryDestinationId) {
      this.clearSelection();
      this.selectDestination(null);
    }
  }

  get destinations(): Destination[] {
    const destinations: Destination[] = this.$store.state.destination.destinations;
    // tslint:disable-next-line:max-line-length
    const mainDestination = destinations.find(d => !!this.mainDestination && d.id === this.mainDestination.destinationId);
    if (!mainDestination) {
      return [];
    }

    return destinations
      .filter(d => d.movitInstanceId === mainDestination.movitInstanceId && d.id !== mainDestination.id);
  }

  get secondaryDestination() {
    if (!this.secondaryDestinationId) {
      return null;
    }
    return this.destinations.find(d => d.id === this.secondaryDestinationId) || null;
  }

  selectDestination(destination: Destination | null) {
    if (!destination) {
      this.$emit('input', null);
      return;
    }
    this.secondaryDestinationId = destination.id;
    this.$emit('input', this.secondaryDestinationId);
  }

  clearSelection() {
    this.secondaryDestinationId = null;
    // this.$emit('input', this.secondaryDestinationId);
  }
}
